import React from 'react';
import styled from "styled-components";
import {device} from "../components/Devices";
import CodePortfolio from "../components/CodePortfolio";
import LandingPage from "../assets/foodieProject/LandingPage.png";
import LoginPage from "../assets/foodieProject/LoginPage.png";
import HomePopular from "../assets/foodieProject/HomePopular.png";
import SearchPage from "../assets/foodieProject/Searchpage.png";
import HealthFilter from "../assets/foodieProject/HealthFilter.png";
import Shoppinglist from "../assets/foodieProject/ShoppingList.png";


function Coding() {

    return (


        <Main_Coding_Container>

            <Header>
                <h1>Cod<span>ing</span></h1>
                <p>Underneath you can see my first major project where I used React to build a webapp. More projects are
                    coming, like this portfolio, but till now only small stuff. Want to see the small
                    stuff? My Github is open so just take a peak... </p>

                <a href="https://github.com/DnZ19">Git<span>hub</span></a>
            </Header>

            <div className="portfolio">

                <CodePortfolio
                    imageOne={LandingPage}
                    imageTwo={LoginPage}
                    imageThree={HomePopular}
                    imageFour={SearchPage}
                    imageFive={HealthFilter}
                    imageSix={Shoppinglist}
                    title="Foodie App"
                    description=

                        "For my end project FE developer at NOVI Hogeschool
                I needed to build a fully working web app. In this app I made a
                connection with a database (Firebase) for user management and
                several API connections to give the user some nice features.
                Some of the features: search, filter on healthy elements and
                a handy shopping list for the needed ingredients.

                The design and technical decisions are 100% mine."
                />


            </div>

        </Main_Coding_Container>


    );
}

export default Coding;


const Header = styled.div`

  width: 320px;
  height: 100%;
  max-height: 150px;
  margin-top: 100px;
  //border: 1px solid blue;
  text-align: center;
  margin-bottom: 20px;


  h1 {
    color: var(--mainTextColor);
    font-weight: lighter;
    font-size: 40px;

    span {
      border-bottom: 2px solid var(--orange);
    }
  }

  p {
    color: var(--blackShadow);
    margin-top: 30px;
    margin-bottom: 20px;
  }

  a {
    color: var(--mainTextColor);
    text-decoration: none;
    font-weight: lighter;
    font-size: 25px;


    span {
      color: var(--orange);
    }
  }

`;

const Main_Coding_Container = styled.div`

  display: flex;
  flex-direction: column;
  align-items: center;
  height: 950px;
  width: 320px;
  max-width: 320px;
  //border: 1px solid yellow;


  @media ${device.mobileM} {
    width: 375px;
    max-width: 375px;
  }

  @media ${device.mobileL} {
    width: 425px;
    max-width: 425px;
  }

  @media ${device.tablet} {
    width: 768px;
    max-width: 768px;
    flex-direction: row;
    justify-content: center;
    flex-wrap: wrap;
    //margin-top: 20px;

  }

  @media ${device.laptop} {
    width: 1420px;
    max-width: 1024px;
  }

  @media ${device.laptopL} {
    max-width: 1440px;
  }


  .portfolio {
    height: 914px;
    width: auto;
    min-width: auto;

    background-color: transparent;
    //margin: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow-y: scroll;
    //border: 1px solid black;

    @media ${device.mobileM} {
      max-width: 375px;
    }

    @media ${device.mobileL} {
      max-width: 425px;
    }

    @media ${device.tablet} {
      width: 600px;
      max-width: 768px;
      //flex-direction: row;
      justify-content: flex-start;
      flex-wrap: wrap;
      //margin-top: 20px;

    }

    @media ${device.laptop} {
      width: 1420px;
      max-width: 1024px;
    }

    @media ${device.laptopL} {
      max-width: 1440px;
    }

  }



`;

